export default __webpack_public_path__ + "static/media/event-hover.8208dc2a.svg";